import { render, staticRenderFns } from "./PrimarySecondaryElement.vue?vue&type=template&id=6386831a&scoped=true&"
import script from "./PrimarySecondaryElement.vue?vue&type=script&lang=ts&"
export * from "./PrimarySecondaryElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6386831a",
  null
  
)

export default component.exports